<template>
    <SlideWhite>
        <div class="h-full grid grid-rows-2 grid-cols-3 gap-[25px]">
            <div
                v-for="(bild, index) in bilder"
                class="h-full relative bg-no-repeat bg-cover bg-center bg-gray-200"
                :key="index"
                :style="{ backgroundImage: `url(${bild.tv.u})`}"
            >
                <!-- <div v-if="bild.titel" class="absolute bg-white text-primary-500 text-[17.333px] left-[45px] bottom-[45px] leading-[35px] px-[25px]">{{ bild.titel }}</div> -->
                <div
                    v-if="index === 6-1"
                    class="absolute left-[45px] bottom-[45px] right-[45px] flex flex-col justify-end space-y-[25px]"
                >
                    <ProjektHeadlineLabel :projekt="projekt" class="text-[22.666px] px-[25px]" />
                    
                    <div class="h-[220px] bg-white/75 p-[25px] text-primary-500">
                        <div class="text-[32px] uppercase font-bold leading-tight mb-[5px]">
                            {{ projekt.r_headline }}
                        </div>
                        <div class="text-[17.333px]" v-show="projekt.objektadresse_freigeben">
                            {{ projekt.strasse }} {{ projekt.hausnummer }} | {{ projekt.r_geolage_name }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </SlideWhite>
</template>

<script>
import SlideWhite from '../Layouts/SlideWhite.vue'
import ProjektHeadlineLabel from '../Partials/ProjektHeadlineLabel.vue'

export default {
    props: {
        bilder: [],
        projekt: null,
    },

    components: {
        SlideWhite,
        ProjektHeadlineLabel,
    }
}
</script>